import React, { useState } from 'react'
import Button from '@tencent/spaui-button'
import { subscribePathName, setPathName } from '../../../router'

let activeTab = '0'
let setActiveTab = () => {}

const handleTabChange = (e, val) => {
    setActiveTab(val)
    // 如果是切到“正在处理”，去掉url中附加的 /processing 路径
    if (val === '0') {
        setPathName('/static/upload_management')
    } else {
        setPathName('/static/upload_management/processing')
    }
}

const listenUrlChange = (e, _path) => {
    const path = _path || window.location.pathname
    if (!path.includes('/upload_management')) {
        // 如果不在 上传管理中心 tab 内
        return
    }
    if (path.includes('/upload_management/processing')) {
        setActiveTab('1')
    } else {
        setActiveTab('0')
    }
}

window.addEventListener('popstate', listenUrlChange)

subscribePathName(path => {
    listenUrlChange(null, path)
})

const useProgressManagement = () => {
    const [_activeTab, _setActiveTab] = useState(activeTab)
    activeTab = _activeTab
    setActiveTab = _setActiveTab
    const [uploadCount, setUploadCount] = useState(0)
    const [processCount, setProcessCount] = useState(0)
    setTimeout(listenUrlChange, 20)

    const LinkButtonComponent = (_props = {}) => {
        const { children = null, name = '', onClick = () => {} } = _props
        return (
            <Button onClick={onClick} data-name={name}>
                {children}
            </Button>
        )
    }

    return {
        LinkButtonComponent,
        handleTabChange,
        activeTab,
        uploadCount,
        setUploadCount,
        processCount,
        setProcessCount,
    }
}

export default useProgressManagement
